import { render, staticRenderFns } from "./inputTabDokLoker.vue?vue&type=template&id=e371af90"
import script from "./inputTabDokLoker.vue?vue&type=script&lang=js"
export * from "./inputTabDokLoker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports